import React from "react"

const NoteMini = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...props}
    >
      <path d="M3.713 12.287h5.374V9.904c0-.227.08-.42.238-.579a.788.788 0 0 1 .579-.238h2.383V3.713H3.713v8.574Zm-.006 1.633c-.448 0-.832-.16-1.15-.48a1.577 1.577 0 0 1-.477-1.153V3.713c0-.45.16-.834.48-1.154.32-.32.704-.48 1.153-.48h8.574c.449 0 .833.16 1.153.48.32.32.48.703.48 1.152v5.25c0 .219-.038.426-.116.623-.078.197-.2.38-.37.548l-3.302 3.303a1.61 1.61 0 0 1-1.171.485H3.707Zm3.655-4.607H5.58a.653.653 0 0 1-.666-.672c0-.188.065-.346.194-.475.13-.13.29-.194.481-.194h1.774c.189 0 .347.063.475.19a.64.64 0 0 1 .191.472.666.666 0 0 1-.191.48.633.633 0 0 1-.475.199Zm3.059-2.541H5.579a.642.642 0 0 1-.475-.194.653.653 0 0 1-.191-.478c0-.188.065-.346.194-.476.13-.129.29-.193.481-.193h4.833c.189 0 .347.063.474.19a.64.64 0 0 1 .192.472.666.666 0 0 1-.192.48.633.633 0 0 1-.474.199Z" />
    </svg>
  )
}

export default NoteMini
